import React from "react";
import "../Pages/Styles/Policy.css";

function Policy() {
  return (
    <div className="container">
      <h1 id="titolo">Centro per la privacy</h1>
      <div className="row">
        <h2>Informazioni sulla privacy</h2>
      </div>
      <div className="row mt-5">
        <div className="col-12">
          <h4>Introduzione</h4>
        </div>
        <div className="col">
          <p>Ferio si impegna a proteggere la privacy dei tuoi dati. </p>
        </div>
      </div>
      <div className="row mt-5">
        <div className="col-12">
          <h4>Quali informazioni raccoglie Ferio?</h4>
        </div>
        <div className="col">
          <p>
            Ferio ti consente di inserire, caricare o memorizzare prenotazioni
            per le tue case vacanze. I tuoi 'Contenuti' non sono oggetto di
            analisi.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Policy;
